import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog37/image1 gamma positive again.png";
import image6 from "../../../../assets/images/Blog37/image 6AllUScos by mktcap.png";
import image27 from "../../../../assets/images/Blog37/image27 ADP leading NFP private down.png";
import image28 from "../../../../assets/images/Blog37/image28 jolts lower than unemployed.png";
import image13 from "../../../../assets/images/Blog37/image13.png";
import image26 from "../../../../assets/images/Blog37/image26 UJ.png";
import image11 from "../../../../assets/images/Blog37/image11 4th strongest SPX surge.png";
import image3 from "../../../../assets/images/Blog37/image3 SPX heat.png";
import image4 from "../../../../assets/images/Blog37/image4 NAS100 heat.png";
import image7 from "../../../../assets/images/Blog37/image7 Stoxx600 heat.png";
import image8 from "../../../../assets/images/Blog37/image8 DAX heat.png";
import image9 from "../../../../assets/images/Blog37/image9 china tech heat.png";
import image10 from "../../../../assets/images/Blog37/image10 non-profit squeeze.png";
import image30 from "../../../../assets/images/Blog37/image30 OCT vol usually highest (1).png";
import image33 from "../../../../assets/images/Blog37/image33 blackout peaks mid october (1).png";
import image34 from "../../../../assets/images/Blog37/image34 SPX shallow pullback is base case (1).png";
import image2 from "../../../../assets/images/Blog37/image2 last week in pictures.png";
import image54 from "../../../../assets/images/Blog37/image54 BTC confirmed wave 4 low boom.png";
import image45 from "../../../../assets/images/Blog37/image45 GOLD extending and in blowoff_.png";
import BlogImagePopper from "./BlogImageLarge";
const Blog37 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – October 6th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Parabolic Moves, AI Mania, and the Wall of Worry</p>
        <p>
          Markets continue to climb the wall of worry, ignoring macro caution as liquidity, leverage, and AI optimism propel equities into parabolic mode. Despite talk of exhaustion, positioning
          remains aggressive and sentiment confident. Private equity is pouring billions into AI and data centres, even as MIT research warns
          <span className="highlightedText"> 95% of these ventures could fail.</span> It’s a classic late-cycle cocktail: abundant liquidity, selective breadth, and traders still “buying the dip”
          while ignoring the cracks underneath.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Calm Indices, Euphoric Internals</p>
              <p>
                Despite rising recession chatter, the market refuses to break stride. After a brief stretch of negative gamma in late Q3, options positioning flipped back into positive territory — a
                key driver behind the relentless upward drift.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Flows remain robust. Bank of America data confirms renewed equity inflows, while insider selling remains muted. Although buyback blackout windows are emerging, the overall liquidity
                backdrop stays strong.
              </p>

              <p>
                Breadth, too, remains supportive. <span className="highlightedText">Advance/Decline lines </span> continue to print fresh highs, defying the “narrow leadership” narrative and keeping
                volatility pinned.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>In short, the market’s surface calm hides mounting leverage and complacency — the same mix that often fuels year-end surges before volatility returns.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: The Fed’s Blind Spot and Data Delays</p>
              <p>
                The ongoing U.S. government shutdown has disrupted critical economic data releases — leaving the Fed partially blind. With
                <span className="highlightedText"> NFP </span> and <span className="highlightedText"> CPI </span> potentially delayed, traders are relying on private indicators like
                <span className="highlightedText"> ADP </span> and <span className="highlightedText"> JOLTS </span> , both flashing early signs of labour softening.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Yet, the <span className="highlightedText">Atlanta Fed GDPNow</span> model still pegs Q3 growth at <span className="highlightedText">3.8%, </span>confirming that real activity remains
                firm.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Yields remain stable, and the bond market shows no panic. Heavy truck sales — a leading recession proxy — are rolling over modestly but not collapsing. Fiscal expansion and policy
                support next year could easily offset these early signs of fatigue.
              </p>
              <p>
                The analyst’s note summarises it best: “The key question isn’t if the Fed cuts, but whether it starts cutting inside or outside a recession.” For now, it still looks like the former.
              </p>
              <p>
                Japan also remains in focus. LDP leader <span className="highlightedText">Sanae Takaichi’s</span> policy stance continues to align fiscal spending with BOJ support — reinforcing
                Japan’s role as a global liquidity anchor.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Late-Cycle Leverage and Behavioural Traps</p>
              <p>
                The ongoing rally now ranks as the <span className="highlightedText">fourth-strongest bull run in modern history </span> — and the largest non-recessionary one ever. The last three of
                similar magnitude all paused briefly at this stage before the Q4 melt-up.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Technically, the <span className="highlightedText">S&P 500 </span> remains in a structured uptrend, consolidating through an ABC correction around key support zones.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The <span className="highlightedText">NASDAQ 100</span> shows a similar rhythm — strong AI and semiconductor leadership, but emerging divergences between price and momentum. These
                divergences hint at a potential sentiment inflexion before the next leg higher.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Sector rotation remains uneven. Energy’s prior dominance faded as oil sold off, while small caps rebounded on rate-cut optimism. Meanwhile, Europe’s{" "}
                <span className="highlightedText">Stoxx600</span> and <span className="highlightedText">DAX</span> continue to outperform, supported by industrials and defence exposure.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>China’s tech sector remains a standout performer, helped by consistent inflows and improving policy sentiment.</p>

              <div className="relatedImg">
                <img
                  src={image9}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image9)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>
                However, the most telling sign of excess is the surge in <span className="highlightedText"> non-profitable tech stocks </span>— a clear echo of 1999-style risk-taking. The analyst’s
                warning is blunt: “Buy it until you lose, because when you want to sell, there won’t be any bids.”
              </p>

              <div className="relatedImg">
                <img
                  src={image10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>
                Volatility remains compressed, but behavioural sentiment is stretched. Options skew suggests traders are heavily leaning long gamma again — a condition that often precedes volatility
                shocks when positioning unwinds.
              </p>
              <div className="relatedImg">
                <img
                  src={image30}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image30)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Buyback blackout windows peak mid-month, historically coinciding with tactical lows before year-end rallies.</p>
              <div className="relatedImg">
                <img
                  src={image33}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image33)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Despite these cyclical dynamics, the broader message stays the same: the trend is up, participation is solid, and dips remain shallow.</p>
              <div className="relatedImg">
                <img
                  src={image34}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image34)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Uptober Ignites</p>
              <p>Markets entered October with strong momentum — risk assets rose broadly across regions and asset classes.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe</span> led with the DAX and Stoxx600 setting fresh highs.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold and Silver</span> continued to surge as safe-haven and speculative demand merged.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. small caps (R2K)</span> outperformed as rate-cut bets returned.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil </span>sold off sharply after OPEC+ shifted focus to volume over price control.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Asia joined the risk-on tone, with <span className="highlightedText">China tech</span> driving inflows and Japan reaffirming fiscal expansion. In the U.S., mega-cap tech consolidated
                while cyclicals caught up.
              </p>

              <p>The first week of “Uptober” lived up to its seasonal reputation — a broad, liquidity-fueled rally.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead – Macro Data Cluster and Central Bank Focus</p>
              <p>With official data limited, traders will focus on speeches, private reports, and volatility dynamics.</p>
              <p className="highlightedText">Monday, Oct 6, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>China National Day Holiday</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone Retail Sales, Construction PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Speakers: de Guindos, Lane, Lagarde</p>
                </li>
                <li className="themesPointer">
                  <p>BOE’s Andrew Bailey</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Oct 7, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>JPY Household Spending, NZ Business Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>NY Fed Consumer Inflation Expectations</p>
                </li>
                <li className="themesPointer">
                  <p>Atlanta GDPNow Q3 Update</p>
                </li>
                <li className="themesPointer">
                  <p>Fed’s Bostic speaks</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Oct 8, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>RBNZ Rate Decision</p>
                </li>

                <li className="themesPointer">
                  <p>BOE MPC Pill</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Minutes (September Meeting)</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Oct 9, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>ECB Meeting Minutes</p>
                </li>

                <li className="themesPointer">
                  <p>Fed Powell & Bowman speeches</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Jobless Claims (subject to release)</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Oct 10, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>University of Michigan Sentiment</p>
                </li>

                <li className="themesPointer">
                  <p>CAD & U.S. Employment Reports (delayed due to shutdown)</p>
                </li>
              </ul>
              <p>With buyback blackouts peaking mid-month and volatility seasonality turning higher, tactical pullbacks could offer short-term entry points for year-end positioning.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image30}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image30)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Risk-On, But Handle With Care</p>
              <p>
                Markets remain firmly risk-on, but the tone is late-cycle and increasingly fragile. AI mania, record liquidity, and heavy positioning keep the melt-up alive, but cracks are forming
                under the surface.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold</span> is running at record highs, its rate of change nearing historical peaks — a potential exhaustion signal even as inflows accelerate.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto </span>is enjoying a classic “Uptober” rally, with <span className="highlightedText">Bitcoin confirming its wave-4 low </span>and
                    institutional flows climbing.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities </span>remain supported by liquidity and seasonality, but leverage and sentiment are overheated. The base case remains a{" "}
                    <span className="highlightedText">shallow 5–7% correction </span> before new highs into year-end.
                  </p>
                </li>
              </ul>
              <p>
                “Don’t want to be Cassandra — but beware of the risks anyway.<br></br>
                Still in uptrend, still risk-on. Just smaller stakes both ways.”
              </p>

              <p>Our stance:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities: </span>Stay long but trim leverage; buy pullbacks.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver: </span>Momentum strong but extended — partial profit-taking prudent.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>Remains constructive; momentum can run further.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro Focus:</span> Fed data blackout impact and OPEC volume strategy.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/14TXl8frymw7T8ydegq_Jti48cvkiSHv40ta4oPRu0cw/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog37;
